import { createFileRoute } from "@tanstack/react-router";
import { GuidesHub } from "./guider.index";

const TITLE = "Guías para comprar y vender por internet | Sellavo";
const DESCRIPTION =
  "Guías prácticas para vender de segunda mano: precios, fotos, texto del anuncio, envío y compras seguras.";

export const Route = createFileRoute("/es/guias")({
  loader: async () => {
    const { GUIDES } = await import("@/lib/guides");
    return {
      guides: GUIDES.map((g) => ({
        slug: g.slug,
        title: g.title,
        description: g.description,
        readMinutes: g.readMinutes,
      })),
    };
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/guias" }],
  }),
  component: GuidesHub,
});
